// extracted by mini-css-extract-plugin
export default {"testSearch":"Utpstvi8LDa_vuA_bLImZ","text-map":"aQQhJIFJ3M6dZbqMGpna-","col-lg-8":"_1BlJYZEDmULMIr02QW0p0I","col-lg-4":"JMdYGP_2b6YK5kDZTUs6I","popupBody":"u7GTy_lA3sje7vQkFVwva"};